module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_3_2.a1361eb1.png";